export const ROUTES = {
  root: "/",
  404: "*",
  login: "/login",
  register: "/register",
  find: "/find",
  company: "/companies",
  user: "/users",
  agent: "/agents",
  consumer: "/consumers",
  customer: "/customers",
  dailyReport: "/reports",
  trash: "/trash",
  imageUpload: "/uploads",
  connection: "/connections",
  account: "/account",
  proudct: "/products",
  refilsales: "/refilsales",
  transaction: "/transaction",
  invoices: "/invoices",
  order: "/orders",
  agentManagement: "/agent-management",
  userManagement: "/user-management",
  refillTransactions: "/refill-transactions",
  cashMemoPunch: "/cash-memo",
  agentDashboard: "/agent-dashboard",
  agentView: "/agent-view",
};